<template>
  <v-content class="contact mb-16">
    <h1
      :class="this.$vuetify.breakpoint.smAndDown ? 'mt-8' : 'mt-16'"
      class="mb-8 font-weight-thin d-flex justify-center"
    >
      Contact
    </h1>
    <v-card max-width="375" class="mx-auto" raised tile>
      <v-img
        src="@/assets/joseph.jpg"
        lazy-src="@/assets/joseph_lazy.png"
        max-height="50vh"
        alt="Joseph Perrin"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
        <!-- <v-row class="fill-height">
        <v-card-title>
          <v-btn icon>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn icon class="mr-4">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </v-card-title>

        <v-spacer></v-spacer>

        <v-card-title class="white--text pl-12 pt-12">
          <div class="display-1 pl-12 pt-12">Ali Conners</div>
        </v-card-title>
      </v-row> -->
      </v-img>
      <v-list two-line>
        <v-list-item>
          <v-list-item-icon class="my-2"
            ><v-btn fab text href="tel: +817031098558" target="_blank">
              <v-icon color="primary">mdi-phone</v-icon></v-btn
            >
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title
              ><a href="tel: +817031098558" target="_blank"
                >+81 70-3109-8558</a
              ></v-list-item-title
            >
            <v-list-item-subtitle>Mobile</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="my-0" inset></v-divider>
        <v-list-item>
          <v-list-item-icon class="my-2"
            ><v-btn
              fab
              text
              href="mailto: jperrin1992@gmail.com"
              target="_blank"
            >
              <v-icon color="primary">mdi-email</v-icon></v-btn
            >
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title
              ><a href="mailto: jperrin1992@gmail.com" target="_blank"
                >jperrin1992@gmail.com</a
              ></v-list-item-title
            >
            <v-list-item-subtitle>Personal</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-0" inset></v-divider>

        <v-list-item>
          <v-list-item-icon class="my-2">
            <v-btn
              fab
              text
              href="https://goo.gl/maps/BpFePV8rehdGjSNG9"
              target="_blank"
              ><v-icon color="primary">mdi-map-marker</v-icon></v-btn
            >
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title
              ><a href="https://goo.gl/maps/BpFePV8rehdGjSNG9" target="_blank"
                >Ikebukuro, Toshima</a
              ></v-list-item-title
            >
            <v-list-item-subtitle>Tokyo 171-0014</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-dialog v-model="dialog" width="600px">
        <v-stepper v-model="e1">
          <v-stepper-header>
            <template v-for="n in steps">
              <v-stepper-step
                :key="`${n}-step`"
                :complete="e1 > n"
                :step="n"
                editable
              >
                {{ stepsTitles[n - 1] }}
              </v-stepper-step>

              <v-divider v-if="n !== steps" :key="n"></v-divider>
            </template>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content
              v-for="n in steps"
              :key="`${n}-content`"
              :step="n"
            >
              <div v-if="n === steps">
                <div v-for="(question, i) in stepsMessages" :key="i">
                  <v-card text-align="center"> {{ stepsMessages[i] }}</v-card>
                  <h6>{{ answersUser[i] }}</h6>
                </div>
              </div>
              <v-textarea
                v-else
                v-model="answersUser[n - 1]"
                clearable
                auto-grow
                :label="stepsMessages[n - 1]"
              ></v-textarea>

              <v-btn v-if="n > 1" @click="back(n)" text>Back</v-btn>
              <v-btn v-else @click="close()" text>Cancel</v-btn>

              <v-btn v-if="n === steps" color="primary" @click="nextStep(n)"
                >Send</v-btn
              >
              <v-btn v-else color="primary" @click="nextStep(n)"
                >Continue</v-btn
              >
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>

        <template v-slot:activator="{ on }">
          <v-btn color="primary" x-large block tile v-on="on">Hire me!</v-btn>
        </template>
      </v-dialog>
    </v-card>

    <!--



  <v-card class="mx-auto card-contact" raised tile>
    <v-img src="@/assets/joseph.png" lazy-src="@/assets/joseph_lazy.png" alt="Joseph Perrin">
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
        </v-row>
      </template>
    </v-img>
  </v-card>
  <v-card class="mx-auto card-contact" raised tile>
    <v-card-text>
      <h2 class="title primary--text">Joseph Perrin</h2>
      <div class="mb-8 mr-2 float-right">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn href="https://github.com/sigmatyk1" fab small color="error" v-on="on">
              <v-icon>mdi-android</v-icon>
            </v-btn>
          </template>
          <span>GitHub</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn href="https://www.linkedin.com/in/joseph-perrin-3b6666152/" class="ml-2" fab small color="indigo" v-on="on">
              <v-icon>mdi-account-circle</v-icon>
            </v-btn>
          </template>
          <span>LinkedIn</span>
        </v-tooltip>
      </div>
      Toshima-ku,Tokyo
      170-0005
      jperrin1992@gmail.com<br />
      +81 70-4201-3218

    </v-card-text>

  </v-card>
 -->
  </v-content>
</template>

<script>
export default {
  data() {
    return {
      e1: 1,
      steps: 3,
      stepsMessages: [
        "Please shortly introduce yourself",
        "Please write down the object of your request",
      ],
      stepsTitles: ["Who", "What", "Check"],
      answersUser: [],
      stepsList: [
        {
          id: "0",
          title: "Who",
          description: "Please shortly introduce yourself",
        },
        {
          id: "1",
          title: "What",
          description: "Please write down the object of your request",
        },
        {
          id: "2",
          title: "Check",
          description: "Is your demand correct?",
        },
      ],
      dialog: false,
    };
  },

  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    },
  },

  methods: {
    nextStep(n) {
      if (n === this.steps) {
        this.close();
        this.sendEmail();
      } else {
        this.e1 = n + 1;
      }
    },
    back(n) {
      this.e1 = n - 1;
    },
    close() {
      this.dialog = false;
    },
    sendEmail() {
      window.open(
        "mailto:jperrin1992@gmail.com?subject=Hiring&body=" +
          this.answersUser[0] +
          "%0D%0A%0D%0A" +
          this.answersUser[1]
      );
    },
  },
};
</script>
<style Scoped>
/* .card-contact {
  max-width: 344px;
} */
</style>
